
const baseURL = {
    // local: 'http://localhost:3082',
    // local: 'http://192.168.1.2',
    local: 'https://test-svc.ecal.com',
    prod: 'https://svc.ecal.com',  
    stage: 'https://stage-svc.ecal.com',  
    test: 'https://test-svc.ecal.com',
};

export default baseURL;
